import Vue from 'vue'


var estadoApp = new Vue({
    data: {
      archivo:'',
    },
    methods: {

    },
    created () {

    }
  })

export default estadoApp